import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="mt-16">
      <div className="text-center mb-12">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">用户口碑</span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
          选手们的真实评价
        </h2>
        <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          来自全国各地选手的真实反馈，是我们不断进步的动力源泉。
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {testimonials.map((t) => (
          <div key={t.id} className="bg-background-100 rounded-xl p-6 flex flex-col">
            <div className="flex items-center gap-1 mb-4">
              {Array.from({ length: t.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-5">&ldquo;{t.content}&rdquo;</p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                <div className="text-xs text-foreground-500">{t.title}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}